import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { alpha, Box, Switch, Typography, useTheme } from "@mui/material";
import { Controller, } from "react-hook-form";
import { ErrorWithIcon } from "./ValidationMessage";
import { useTranslation } from "react-i18next";
export const HSwitchGroup = ({ options, name, control, label, rules, error, defaultValue, disabled, containerStyles, dateCounts, fullDates, shouldDisableFullDates, usedInExternal = false, optionLabelStyles, optionContainerStyles, }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    return (_jsxs(Box, { children: [_jsxs(Box, { sx: {
                    px: 2,
                    py: 3,
                    borderColor: error
                        ? theme.palette.error.main
                        : alpha(theme.palette.edark.main, 0.2),
                    borderRadius: 1,
                    borderWidth: "1px",
                    borderStyle: "solid",
                    ...containerStyles,
                }, children: [_jsx(Typography, { variant: "subtitle1", fontWeight: 500, color: error ? "error" : "#00244D", children: label }), _jsx(Controller, { name: name, control: control, rules: rules, render: ({ field }) => {
                            const selectedValues = field.value || []; // Initialize as an empty array if undefined
                            // const handleToggle = (value: string) => {
                            //   const newValues = selectedValues.includes(value)
                            //     ? selectedValues.filter((v: string) => v !== value) // Remove if exists
                            //     : [...selectedValues, value]; // Add if not exists
                            //   field.onChange(newValues);
                            // };
                            const handleToggle = (value) => {
                                const rawValues = selectedValues.map((v) => typeof v === "string" ? v : v?.value);
                                const newValues = rawValues.includes(value)
                                    ? rawValues.filter((v) => v !== value)
                                    : [...rawValues, value];
                                field.onChange(newValues); // <- Send value array
                            };
                            return (_jsx(_Fragment, { children: options.map((option, index) => {
                                    const countInfo = dateCounts?.find((c) => c.eventDateId === option.value);
                                    const invitedText = countInfo
                                        ? `(${countInfo.invitedCount}/${countInfo.allowedPerDateCount} ${t("event.occupied")})`
                                        : usedInExternal
                                            ? `(0/2 ${t("event.occupied")})`
                                            : "";
                                    // Return the Box component properly (removed semicolon and added return)
                                    return (_jsxs(Box, { sx: {
                                            ...optionContainerStyles,
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }, children: [_jsxs(Typography, { variant: "subtitle2", color: "initial", sx: { ...optionLabelStyles, flexGrow: 1 }, children: [option.label, " ", invitedText] }), _jsx(Switch, { checked: selectedValues.some((v) => typeof v === "string"
                                                    ? v === option.value
                                                    : v?.value === option.value), onChange: () => handleToggle(option.value), disabled: disabled ||
                                                    (shouldDisableFullDates && fullDates?.[option.value]) })] }, index));
                                }) }));
                        } })] }), _jsx(ErrorWithIcon, { error: error })] }));
};
